module.exports = __webpack_public_path__ + "img/Stoferno-Credit-Card.0f386dc8.png";